<template>
  <div class="chart">
    <div id="my-chart"></div>
  </div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
export default {
  name: "hiddenDangerPie",
  components: {},
  props: {
    echartsData: {
      type: Array,
      default: {
        return: {},
      },
    },
  },
  data() {
    return {
      myChart: {},
    };
  },
  created() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.reflow();
    // };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadChart();
    });
  },
  computed: {},
  watch: {
    echartsData: function (newVal) {
      this.loadChart();
    },
  },
  methods: {
    loadChart() {
      let option = {
        chart: {
          type: "pie",
          backgroundColor: "rgba(0,0,0,0)",
          borderColor: "rgba(0,0,0,0)",
          options3d: {
            enabled: true,
            alpha: 65,
            beta: 0,
          },
          spacing: [0, 0, 0, 0],
        },
        colors: [
          "#107CE4",
          "#FDB006",
          "#7516F6",
          "#71D6FF",
          "#F13A3A",
          "#C474FF",
        ],
        title: {
          floating: true,
          useHTML: false,
          text: "",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        // 6,22,58
        legend: {
          enabled: true,
          align: "center",
          // floating: true,
          layout: "horizontal",
          itemMarginBottom: 5,
          symbolRadius: 0,
          itemStyle: {
            color: "#ffffff",
            fontSize: "12px",
            fontWeight: 400,
            opacity: 1,
          },
          itemHoverStyle: { color: "#ffffff", opacity: 0.5 },
          verticalAlign: "bottom",
          margin: 0,
        },
        noData: {},
        credits: {
          enabled: false, // 是否显示版权信息
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 20,
            dataLabels: {
              enabled: true,
              // inside: true,
              crop: false,
              // overflow: none,
              distance: 10,
              format: "{point.percentage:.1f}%",
              borderColor: "rgba(0,0,0,0)",
              style: {
                color: "#fff",
                fontSize: "12px",
                textOutline: "0px 0px contrast",
              },
            },
            showInLegend: true, //重点图例显示
            borderColor: "rgba(0,0,0,0)",
          },
        },
        series: [
          {
            type: "pie",
            name: "隐患分类",
            data: [],
          },
        ],
      };
      // console.log(this.echartsData)
      // console.log(option.series)

      option.series[0].data = this.echartsData.map((item) => {
        // console.log(item);
        return {
          name: item.name || "",
          y: item.value || 0,
        };
      });

      this.myChart = Highcharts.chart("my-chart", option);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.chart {
  padding-top: 50px;
  #my-chart {
    height: 190px;
  }
}
</style>
